import styled from 'styled-components'
// import { space } from 'styled-system'

// import { default as VARIABLES } from '../../themes/styles/variables'

export const TextEditorStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  .text-editor {
    .note-editor {
      &.panel-default {
        & > .panel-heading {
          color: #333;
          background-color: #f5f5f5;
          border-color: #ddd;
          padding: 10px 15px;
          border-bottom: 1px solid transparent;
          border-top-left-radius: 3px;
          border-top-right-radius: 3px;

          &.note-toolbar {
            padding: 0 0 5px 5px;
            margin: 0;
          }
        }
      }
    }

    .note-statusbar {
      display: none;
    }
  }

  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;

    &:hover {
      color: #333;
      text-decoration: none;
    }

    &:focus {
      color: #333;
      text-decoration: none;
    }

    &.btn-default {
      color: #333;
      background-color: #fff;
      border-color: #ccc;

      &:hover {
        color: #333;
        background-color: #e6e6e6;
        border-color: #adadad;
      }

      &:focus {
        color: #333;
        background-color: #e6e6e6;
        border-color: #8c8c8c;
      }
    }
  }

  .btn-group {
    position: relative;
    display: inline-block;
    vertical-align: middle;

    .btn {
      & + .btn {
        margin-left: -1px;
      }

      & + .btn-group {
        margin-left: -1px;
      }
    }

    .btn-gruop {
      & + .btn {
        margin-left: -1px;
      }

      & + .btn-group {
        margin-left: -1px;
      }
    }

    & > .btn-group {
      float: left;
    }

    & > .btn {
      position: relative;
      float: left;

      &:hover {
        z-index: 2;
      }
    }
  }

  .btn-group-vertical {
    position: relative;
    display: inline-block;
    vertical-align: middle;
  }

  .btn-sm,
  .btn-group-sm > .btn {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
  }

  .open > .dropdown-menu {
    display: block;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  }

  .dropdown-menu > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
  }

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
